import React from 'react';

import { BaseContactLensModal } from '../Modal';
import { BOXES_QUANTITY_MODAL_LIST } from '../constants';

export const BoxesQuantityModal = props => {
  const { isOpen, onClose, eye, value, onSelect } = props;

  return (
    <BaseContactLensModal
      isOpen={isOpen}
      list={BOXES_QUANTITY_MODAL_LIST}
      title={`Boxes Quantity (${eye} Eye)`}
      value={value}
      onClose={onClose}
      onSelect={onSelect}
    />
  );
};
